import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { listenForDeepLinks } from "@/lib/native";
import { PremiumProvider } from "@/context/PremiumContext";
import { PaywallTrigger } from "@/components/PaywallTrigger";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import RecipeDetail from "@/pages/RecipeDetail";
import RecipeList from "@/pages/RecipeList";
import Simulator from "@/pages/Simulator";
import RiceSimulator from "@/pages/RiceSimulator";
import SaucepanSimulator from "@/pages/SaucepanSimulator";
import Achievements from "@/pages/Achievements";
import Paywall from "@/pages/Paywall";
import PaywallSuccess from "@/pages/PaywallSuccess";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import MealPlan from "@/pages/MealPlan";
import GroceryList from "@/pages/GroceryList";
import SavedRecipes from "@/pages/SavedRecipes";
import Settings from "@/pages/Settings";
import AuthVerify from "@/pages/AuthVerify";
import Support from "@/pages/Support";
import { Privacy, Terms } from "@/pages/Legal";

const DeepLinks = () => {
  const navigate = useNavigate();
  useEffect(() => { listenForDeepLinks(navigate); }, [navigate]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <DeepLinks />
      <PremiumProvider>
        <Layout>
          <PaywallTrigger />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/recipes" element={<RecipeList />} />
            <Route path="/recipe/:slug" element={<RecipeDetail />} />
            <Route path="/simulator" element={<Simulator />} />
            <Route path="/simulator/boiled-rice" element={<RiceSimulator />} />
            <Route path="/simulator/saucepan-heating" element={<SaucepanSimulator />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/premium" element={<Paywall />} />
            <Route path="/premium/success" element={<PaywallSuccess />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:slug" element={<CollectionDetail />} />
            <Route path="/meal-plan" element={<MealPlan />} />
            <Route path="/grocery-list" element={<GroceryList />} />
            <Route path="/saved" element={<SavedRecipes />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/auth/verify" element={<AuthVerify />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/support" element={<Support />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </PremiumProvider>
    </BrowserRouter>
  );
}

export default App;
